import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const soundbiteSentimentResolver: FieldResolver = (metadata: Metadata) =>
  ({ soundbiteSentiment: metadata.getSoundbiteSentiment() } as StreamData)

export default soundbiteSentimentResolver
